import React from 'react';

import {useAiUsage} from 'src/modules/ai';
import {UserFeedbackModalView} from 'src/modules/ai/user-feedback/user-feedback-modal.view';
import {saveFeedback} from 'src/openapi/apis/UserFeedbackControllerApi';
import {UserFeedback} from 'src/openapi/models/UserFeedback';
import {useAppDispatch} from 'src/store';

import {Icons} from '@pb/kit-component-icon';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

type Props = {
    changeRequestId: number,
    show: boolean,
    setShow: (show: boolean) => void,
};

const SUCCESS_AUTO_HIDE_TIMEOUT = 2000;
const ERROR_AUTO_HIDE_TIMEOUT = 10000;

export const UserFeedbackModalController = (props: Props) => {
    const {
        changeRequestId,
        show,
        setShow,
    } = props;

    const {onCreateNote} = usePushNotification();
    const dispatch = useAppDispatch();
    const {cleanAiUsed} = useAiUsage(changeRequestId);

    const onSendFeedback = async (userFeedback: UserFeedback) => {
        const response = await dispatch(saveFeedback({userFeedback}));

        if (response.payload.success) {
            onCreateNote({
                id: 'SavedSaveFeedback',
                status: Status.SUCCESS,
                message: 'Saved',
                buttonProps: {iconProps: {type: Icons.CLOSE}},
                autoHideTimeout: SUCCESS_AUTO_HIDE_TIMEOUT,
            });

            cleanAiUsed();
            setShow(false);
        }

        if (response.payload.error) {
            onCreateNote({
                id: 'errorSaveFeedback',
                status: Status.ERROR,
                message: response.payload.data.message,
                buttonProps: {iconProps: {type: Icons.CLOSE}},
                autoHideTimeout: ERROR_AUTO_HIDE_TIMEOUT,
            });
        }
    };

    return (
        <UserFeedbackModalView
            changeRequestId={changeRequestId}
            show={show}
            setShow={setShow}
            onSendFeedback={onSendFeedback}
        />
    );
};
